import React from 'react';
import styles from './FrameInfoView.module.scss';
import SpriteFrame from '../SpriteFrame';
import { IconButton } from 'components/common';
import { icons } from 'assets';
import TimeIntervalsInfoBlob from '../TimeIntervalsInfoBlob';
import { FrameInfoViewProps } from './types';

const FrameInfoView = (props: FrameInfoViewProps) => {
  const {
    className = '',
    onClick = null,
    previewFrame = 1,
    name = '',
    isSelectable = false,
    isSelected = false,
    shotsCount = 0,
    timeIntervals = null
  } = props;
  const [showTimeIntervals, setShowTimeIntervalsFlag] = React.useState(false);

  const containerStyles = [styles.container];
  isSelectable && containerStyles.push(styles.containerPointer);
  containerStyles.push(className);

  return (
    <div
      className={containerStyles.join(' ')}
      onClick={isSelectable ? onClick : null}
    >
      <SpriteFrame frameNumber={previewFrame} size='m' />
      {(isSelectable && !isSelected) && <div className={styles.selectionIndicator} />}
      <div className={styles.infoBar}>
        <span>{name}</span>
        <span>
          {shotsCount} shots
          {timeIntervals &&
            <IconButton
              icon={icons.info}
              onClick={() => setShowTimeIntervalsFlag(!showTimeIntervals)}
            />
          }
        </span>
      </div>
      {showTimeIntervals &&
        <TimeIntervalsInfoBlob
          hide={() => setShowTimeIntervalsFlag(false)}
          timeIntervals={timeIntervals}
        />
      }
    </div>
  );
};

export default FrameInfoView;
